<template>
<!--  <v-dialog v-model="dialogStatus"-->
<!--            persistent-->
<!--            max-width="800px">-->
    <div class="fill-height">
      <v-card class="fill-height">
        <v-card-subtitle>تعریف کار اصلی</v-card-subtitle>
          <v-spacer/>
          <v-card-text>
           <v-form  ref="form" @submit.prevent="save" lazy-validation v-model="valid">
            <v-row>
              <v-col
                  cols="12"
                  sm="4"
                  md="4">
                <v-autocomplete
                    :items="data.mainGroupItems"
                    v-model="model.mainGroupId"
                    @input="handleInput"
                    dense
                    outlined
                    @change="getSubGroupList"
                    :error-messages="getError('mainGroupId')"
                    auto-select-first  append-icon="fas fa-angle-down"
                    label="انتخاب گروه اصلی"

                />

              </v-col>
              <v-col
                  cols="12"
                  sm="4"
                  md="4">
                <v-autocomplete
                    :items="subGroupItems"
                    v-model="model.subGroupListText"
                    @input="handleInput"
                    dense
                    multiple
                    outlined
                    :error-messages="getError('subGroupListText')"
                    auto-select-first  append-icon="fas fa-angle-down"
                    label="انتخاب گروه فرعی"

                />

              </v-col>
              <v-col
                  cols="12"
                  sm="4"
                  md="4">

                <v-text-field
                    label="نام "
                    outlined
                    dense
                    :error-messages="getError('name')"
                    v-model="model.name"
                />

              </v-col>
              <v-col
                  cols="12"
                  sm="4"
                  md="4">

                <v-text-field
                    label="درصد تخفیف "
                    outlined
                    dense
                    type="number"
                    :error-messages="getError('discountPercent')"
                    v-model="model.discountPercent"
                />

              </v-col>
              <v-col
                  cols="12"
                  sm="4"
                  md="4">

                <v-text-field
                    label="تلفن"
                    outlined
                    dense
                    :error-messages="getError('phone')"
                    v-model="model.phone"
                />

              </v-col>

              <v-col
                  cols="12"
                  sm="4"
                  md="4">
                <date-picker placeholder="تاریخ انقضاء" v-model="model.expirdText" color="#3b5694" clearable
                             auto-submit>
                </date-picker>
                <span style="color: red" v-if="getError('expirdText')" v-text="getError('expirdText')"/>
              </v-col>

              <v-col
                  cols="12"
                  sm="12"
                  md="12">

                <v-textarea
                    label="آدرس"
                    outlined
                    dense
                    :error-messages="getError('address')"
                    v-model="model.address"
                />

              </v-col>
            </v-row>


            <v-divider class="p-0 m-0"/>
            <v-card-actions dir="ltr">

              <v-btn
                 small
                 depressed
                  color="primary"
                  class=" pr-1 pl-1"
                  type="submit"
                 :loading="loading"
              >
                ذخیره
              </v-btn>
              <v-btn
                  small
                  depressed
                  color="error"
                  class=" p-1 m-1"
                  @click="closed"
              >
                لغو
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
<!--  </v-dialog>-->
</template>

<script>
import MainJob_se from "./MainJob_se";



export default {


  data() {
    return {
      bindingErrors: [],
      subGroupItems: [],
      loading: false,
      data:{},
      model:{},
      id: '',
      valid: true,
    }
  },




  methods: {
    handleInput (value) {
      this.$emit('input', value)
    },
    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },

    getSubGroupList(val){
      MainJob_se.getSubGroupList(val).then(response=>{
        return  this.subGroupItems=response.data.subGroupItems
      })
    },

    closed() {
      this.bindingErrors=[]
      this.loading=false
      this.$root.$emit('MainJob' )
      this.$router.go(-1)


    },


    save() {
      this.loading=true
      this.bindingErrors = []
      this.$progress({message: 'درحال ثبت ...'}, true)
      MainJob_se.save(this.model).then(response => {

            if (response && response.status === 200) {
            this.$root.$emit('Progress')
            this.$snack({type: 'success'})
            this.closed()
          }else if (response && response.response.status === 400) {
            this.loading=false
            this.$root.$emit('Progress')
            this.bindingErrors = response.response.data;
          }
        })

    },


    fetch() {
      MainJob_se.getById(this.modelId).then(response => {
        this.data = response.data
        this.model = response.data.model
        if(this.model.mainGroupId){
          this.getSubGroupList(this.model.mainGroupId)
        }
      })

    },
    forEdit: function () {
      this.modelId = this.id;
      this.fetch()
    },

    forNew: function () {
      this.data = {};
      this.modelId = '';
      this.fetch()
    },

  },
  created() {
    this.id=this.$route.query.id
    if(this.id==='new'){
      this.forNew()
    }else {
      this.forEdit()
    }
  },



}
</script>


